var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25239 6.35259C3.17467 6.4061 3.11112 6.47771 3.06721 6.56124C3.02331 6.64477 3.00037 6.73772 3.00037 6.83209C3.00037 6.92645 3.02331 7.0194 3.06721 7.10293C3.11112 7.18646 3.17467 7.25807 3.25239 7.31159L10.8357 12.5616C10.9232 12.6224 11.0256 12.658 11.1319 12.6646C11.2382 12.6713 11.3443 12.6486 11.4387 12.5992C11.533 12.5498 11.612 12.4754 11.6671 12.3843C11.7221 12.2931 11.7511 12.1886 11.751 12.0821L11.751 1.58209C11.7505 1.47583 11.7211 1.3717 11.6659 1.2809C11.6108 1.1901 11.5319 1.11606 11.4377 1.06675C11.3436 1.01744 11.2378 0.994719 11.1317 1.00103C11.0257 1.00735 10.9233 1.04246 10.8357 1.10259L3.25239 6.35259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.69b570d0f1029e983f1553262f230e30.svg";
export { ForwardRef as ReactComponent };